import {
    type FC
} from "react";
import {
    Platform
} from "react-native";
import type {
    EmptyPartContentProps,
    IEmptyTitleProps
} from "../../type";
import {
    withEmptyContext
} from "../../context";
import stylesheet, {
    EMPTY_TITLE_SKELETON_WIDTH,
    EMPTY_HEADING_LEVEL
} from "../../stylesheet";
import Skeleton from "../../../skeleton";
import Text from "../../../text";

const EmptyTitleBase: FC<EmptyPartContentProps<IEmptyTitleProps>> = ({
    customTheme: customThemeProp,
    children,
    context,
    style,
    ...props
}) => {
    const customTheme = customThemeProp ?? context.customTheme;

    const headingProps = Platform.OS === "web" ? {
        "aria-level": EMPTY_HEADING_LEVEL
    } : {};

    if(context.isLoading) {
        return <Skeleton
            typography={context.measures.titleVariant}
            width={EMPTY_TITLE_SKELETON_WIDTH}
            customTheme={customTheme}
            variant="text"
        />;
    }

    return <Text
        {...headingProps}
        {...props}
        customColor={context.colors.titleColor}
        variant={context.measures.titleVariant}
        customTheme={customTheme}
        style={[
            style,
            stylesheet.title
        ]}
        role="heading"
    >
        {children}
    </Text>;
};
export default withEmptyContext("title", EmptyTitleBase);
